module.exports = __webpack_public_path__ + "static/media/face-male-1.4cce40f7.jpg";